import { BaseNomDTO, CheckUpDTO, DocumentDTO, FormAccessDTO } from "./ClientDTO";
import { BaseDTO } from "./DashboardWidgetDTO";
import { ServiceDTO } from "./Scheduler/SchedulerClient";

export class MedicalAnalysisBatchDTO implements IMedicalAnalysisBatchDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    description?: string | null;
    medicalAnalysisBatchStatus?: MedicalAnalysisBatchStatusDTO;
    appointmentId?: number | null;
    samplingType?: SamplingTypeDTO;
    scheduledDate?: Date | null;
    medicalAnalysisBatchDate?: Date | null;
    recommendedDate?: Date | null;
    receiptId?: number | null;
    referralDoctorId?: number | null;

    constructor(data?: IMedicalAnalysisBatchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.medicalAnalysisBatchStatus = _data["medicalAnalysisBatchStatus"] ? MedicalAnalysisBatchStatusDTO.fromJS(_data["medicalAnalysisBatchStatus"]) : <any>null;
            this.appointmentId = _data["appointmentId"] !== undefined ? _data["appointmentId"] : <any>null;
            this.samplingType = _data["samplingType"] ? SamplingTypeDTO.fromJS(_data["samplingType"]) : <any>null;
            this.scheduledDate = _data["scheduledDate"] ? new Date(_data["scheduledDate"].toString()) : <any>null;
            this.medicalAnalysisBatchDate = _data["medicalAnalysisBatchDate"] ? new Date(_data["medicalAnalysisBatchDate"].toString()) : <any>null;
            this.recommendedDate = _data["recommendedDate"] ? new Date(_data["recommendedDate"].toString()) : <any>null;
            this.receiptId = _data["receiptId"] !== undefined ? _data["receiptId"] : <any>null;
            this.referralDoctorId = _data["referralDoctorId"] !== undefined ? _data["referralDoctorId"] : <any>null;
        }
    }

    static fromJS(data: any): MedicalAnalysisBatchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAnalysisBatchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["medicalAnalysisBatchStatus"] = this.medicalAnalysisBatchStatus ? this.medicalAnalysisBatchStatus.toJSON() : <any>null;
        data["appointmentId"] = this.appointmentId !== undefined ? this.appointmentId : <any>null;
        data["samplingType"] = this.samplingType ? this.samplingType.toJSON() : <any>null;
        data["medicalAnalysisBatchDate"] = this.medicalAnalysisBatchDate ? this.medicalAnalysisBatchDate.toISOString() : <any>null;
        data["recommendedDate"] = this.recommendedDate ? this.recommendedDate.toISOString() : <any>null;
        data["receiptId"] = this.receiptId !== undefined ? this.receiptId : <any>null;
        data["referralDoctorId"] = this.referralDoctorId !== undefined ? this.referralDoctorId : <any>null;
        return data;
    }
}

export interface IMedicalAnalysisBatchDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    description?: string | null;
    medicalAnalysisBatchStatus?: MedicalAnalysisBatchStatusDTO;
    appointmentId?: number | null;
    samplingType?: SamplingTypeDTO;
    scheduledDate?: Date | null;
    medicalAnalysisBatchDate?: Date | null;
    recommendedDate?: Date | null;
    receiptId?: number | null;
    referralDoctorId?: number | null;
}




export class MedicalAnalysisBatchDTOFormItemResult implements IMedicalAnalysisBatchDTOFormItemResult {
  entityDTO?: MedicalAnalysisBatchDTO;
  formAccess?: FormAccessDTO;

  constructor(data?: IMedicalAnalysisBatchDTOFormItemResult) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.entityDTO = _data["entityDTO"] ? MedicalAnalysisBatchDTO.fromJS(_data["entityDTO"]) : <any>null;
          this.formAccess = _data["formAccess"] ? FormAccessDTO.fromJS(_data["formAccess"]) : <any>null;
      }
  }

  static fromJS(data: any): MedicalAnalysisBatchDTOFormItemResult {
      data = typeof data === 'object' ? data : {};
      let result = new MedicalAnalysisBatchDTOFormItemResult();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["entityDTO"] = this.entityDTO ? this.entityDTO.toJSON() : <any>null;
      data["formAccess"] = this.formAccess ? this.formAccess.toJSON() : <any>null;
      return data;
  }
}

export interface IMedicalAnalysisBatchDTOFormItemResult {
  entityDTO?: MedicalAnalysisBatchDTO;
  formAccess?: FormAccessDTO;
}

export class MedicalAnalysisBatchStatusDTO implements IMedicalAnalysisBatchStatusDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IMedicalAnalysisBatchStatusDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): MedicalAnalysisBatchStatusDTO {
      data = typeof data === 'object' ? data : {};
      let result = new MedicalAnalysisBatchStatusDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IMedicalAnalysisBatchStatusDTO {
  id?: number;
  name?: string | null;
}

export class MedicalAnalysisGroupDTO implements IMedicalAnalysisGroupDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    abbr?: string | null;

    constructor(data?: IMedicalAnalysisGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.abbr = _data["abbr"] !== undefined ? _data["abbr"] : <any>null;
        }
    }

    static fromJS(data: any): MedicalAnalysisGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAnalysisGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["abbr"] = this.abbr !== undefined ? this.abbr : <any>null;
        return data;
    }
}

export interface IMedicalAnalysisGroupDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    abbr?: string | null;
}
export class MedicalAnalysisDTO implements IMedicalAnalysisDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    sampleType?: SampleTypeDTO;
    samplingType?: SamplingTypeDTO;
    defaultMedicalAnalysisTestsChecked?: boolean | null;
    active?: boolean | null;
    canChooseTests?: boolean | null;
    medicalAnalysisGroup?: MedicalAnalysisGroupDTO;
    medicalAnalysisType?: BaseNomDTO;
    service?: ServiceDTO;
    doNotMixTubes?: boolean | null;

    constructor(data?: IMedicalAnalysisDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sampleType = _data["sampleType"] ? SampleTypeDTO.fromJS(_data["sampleType"]) : <any>null;
            this.samplingType = _data["samplingType"] ? SamplingTypeDTO.fromJS(_data["samplingType"]) : <any>null;
            this.defaultMedicalAnalysisTestsChecked = _data["defaultMedicalAnalysisTestsChecked"] !== undefined ? _data["defaultMedicalAnalysisTestsChecked"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.canChooseTests = _data["canChooseTests"] !== undefined ? _data["canChooseTests"] : <any>null;
            this.medicalAnalysisGroup = _data["medicalAnalysisGroup"] ? MedicalAnalysisGroupDTO.fromJS(_data["medicalAnalysisGroup"]) : <any>null;
            this.medicalAnalysisType = _data["medicalAnalysisType"] ? BaseNomDTO.fromJS(_data["medicalAnalysisType"]) : <any>null;
            this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>null;
            this.doNotMixTubes = _data["doNotMixTubes"] !== undefined ? _data["doNotMixTubes"] : <any>null;
        }
    }

    static fromJS(data: any): MedicalAnalysisDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAnalysisDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sampleType"] = this.sampleType ? this.sampleType.toJSON() : <any>null;
        data["samplingType"] = this.samplingType ? this.samplingType.toJSON() : <any>null;
        data["defaultMedicalAnalysisTestsChecked"] = this.defaultMedicalAnalysisTestsChecked !== undefined ? this.defaultMedicalAnalysisTestsChecked : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["canChooseTests"] = this.canChooseTests !== undefined ? this.canChooseTests : <any>null;
        data["medicalAnalysisGroup"] = this.medicalAnalysisGroup ? this.medicalAnalysisGroup.toJSON() : <any>null;
        data["medicalAnalysisType"] = this.medicalAnalysisType ? this.medicalAnalysisType.toJSON() : <any>null;
        data["service"] = this.service ? this.service.toJSON() : <any>null;
        data["doNotMixTubes"] = this.doNotMixTubes !== undefined ? this.doNotMixTubes : <any>null;
        return data;
    }
}

export interface IMedicalAnalysisDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    sampleType?: SampleTypeDTO;
    samplingType?: SamplingTypeDTO;
    defaultMedicalAnalysisTestsChecked?: boolean | null;
    active?: boolean | null;
    canChooseTests?: boolean | null;
    medicalAnalysisGroup?: MedicalAnalysisGroupDTO;
    medicalAnalysisType?: BaseNomDTO;
    service?: ServiceDTO;
    doNotMixTubes?: boolean | null;
}

export class SampleTypeDTO implements ISampleTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;

    constructor(data?: ISampleTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
        }
    }

    static fromJS(data: any): SampleTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SampleTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        return data;
    }
}

export interface ISampleTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
}

export class SamplingTypeDTO implements ISamplingTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
    service?: ServiceDTO;

    constructor(data?: ISamplingTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>null;
        }
    }

    static fromJS(data: any): SamplingTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SamplingTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["service"] = this.service ? this.service.toJSON() : <any>null;
        return data;
    }
}

export interface ISamplingTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
    service?: ServiceDTO;
}
export class MedicalAnalysisResultDTO implements IMedicalAnalysisResultDTO {
    id?: number;
    writeRevision?: boolean | null;
    medicalAnalysisBatch?: MedicalAnalysisBatchDTO;
    checkUp?: CheckUpDTO;
    medicalAnalysis?: MedicalAnalysisDTO;
    medicalAnalysisResultStatus?: BaseNomDTO;
    sampleType?: BaseNomDTO;
    laboratoryDate?: Date | null;
    sampleDate?: Date | null;
    resultsDate?: Date | null;
    laboratory?: BaseNomDTO;
    receiptServiceId?: number | null;
    registerNumber?: number;
    externalLaboratory?: BaseNomDTO;
    uniqueNumber?: number;
    hasInvalidTests?: boolean | null;
    quantitySampled?: string | null;
    expressMedicalAnalysisValue?: string | null;
    isExpress?: boolean | null;
    isSelected?: boolean | null;

    constructor(data?: IMedicalAnalysisResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.medicalAnalysisBatch = _data["medicalAnalysisBatch"] ? MedicalAnalysisBatchDTO.fromJS(_data["medicalAnalysisBatch"]) : <any>null;
            this.checkUp = _data["checkUp"] ? CheckUpDTO.fromJS(_data["checkUp"]) : <any>null;
            this.medicalAnalysis = _data["medicalAnalysis"] ? MedicalAnalysisDTO.fromJS(_data["medicalAnalysis"]) : <any>null;
            this.medicalAnalysisResultStatus = _data["medicalAnalysisResultStatus"] ? BaseNomDTO.fromJS(_data["medicalAnalysisResultStatus"]) : <any>null;
            this.sampleType = _data["sampleType"] ? BaseNomDTO.fromJS(_data["sampleType"]) : <any>null;
            this.laboratoryDate = _data["laboratoryDate"] ? new Date(_data["laboratoryDate"].toString()) : <any>null;
            this.sampleDate = _data["sampleDate"] ? new Date(_data["sampleDate"].toString()) : <any>null;
            this.resultsDate = _data["resultsDate"] ? new Date(_data["resultsDate"].toString()) : <any>null;
            this.laboratory = _data["laboratory"] ? BaseNomDTO.fromJS(_data["laboratory"]) : <any>null;
            this.receiptServiceId = _data["receiptServiceId"] !== undefined ? _data["receiptServiceId"] : <any>null;
            this.registerNumber = _data["registerNumber"] !== undefined ? _data["registerNumber"] : <any>null;
            this.externalLaboratory = _data["externalLaboratory"] ? BaseNomDTO.fromJS(_data["externalLaboratory"]) : <any>null;
            this.uniqueNumber = _data["uniqueNumber"] !== undefined ? _data["uniqueNumber"] : <any>null;
            this.hasInvalidTests = _data["hasInvalidTests"] !== undefined ? _data["hasInvalidTests"] : <any>null;
            this.quantitySampled = _data["quantitySampled"] !== undefined ? _data["quantitySampled"] : <any>null;
            this.expressMedicalAnalysisValue = _data["expressMedicalAnalysisValue"] !== undefined ? _data["expressMedicalAnalysisValue"] : <any>null;
            this.isExpress = _data["isExpress"] !== undefined ? _data["isExpress"] : <any>null;
        }
    }

    static fromJS(data: any): MedicalAnalysisResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAnalysisResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["medicalAnalysisBatch"] = this.medicalAnalysisBatch ? this.medicalAnalysisBatch.toJSON() : <any>null;
        data["checkUp"] = this.checkUp ? this.checkUp.toJSON() : <any>null;
        data["medicalAnalysis"] = this.medicalAnalysis ? this.medicalAnalysis.toJSON() : <any>null;
        data["medicalAnalysisResultStatus"] = this.medicalAnalysisResultStatus ? this.medicalAnalysisResultStatus.toJSON() : <any>null;
        data["sampleType"] = this.sampleType ? this.sampleType.toJSON() : <any>null;
        data["laboratoryDate"] = this.laboratoryDate ? this.laboratoryDate.toISOString() : <any>null;
        data["sampleDate"] = this.sampleDate ? this.sampleDate.toISOString() : <any>null;
        data["resultsDate"] = this.resultsDate ? this.resultsDate.toISOString() : <any>null;
        data["laboratory"] = this.laboratory ? this.laboratory.toJSON() : <any>null;
        data["receiptServiceId"] = this.receiptServiceId !== undefined ? this.receiptServiceId : <any>null;
        data["registerNumber"] = this.registerNumber !== undefined ? this.registerNumber : <any>null;
        data["externalLaboratory"] = this.externalLaboratory ? this.externalLaboratory.toJSON() : <any>null;
        data["uniqueNumber"] = this.uniqueNumber !== undefined ? this.uniqueNumber : <any>null;
        data["hasInvalidTests"] = this.hasInvalidTests !== undefined ? this.hasInvalidTests : <any>null;
        data["quantitySampled"] = this.quantitySampled !== undefined ? this.quantitySampled : <any>null;
        data["expressMedicalAnalysisValue"] = this.expressMedicalAnalysisValue !== undefined ? this.expressMedicalAnalysisValue : <any>null;
        data["isExpress"] = this.isExpress !== undefined ? this.isExpress : <any>null;
        return data;
    }
}

export interface IMedicalAnalysisResultDTO {
    id?: number;
    writeRevision?: boolean | null;
    medicalAnalysisBatch?: MedicalAnalysisBatchDTO;
    checkUp?: CheckUpDTO;
    medicalAnalysis?: MedicalAnalysisDTO;
    medicalAnalysisResultStatus?: BaseNomDTO;
    sampleType?: BaseNomDTO;
    laboratoryDate?: Date | null;
    sampleDate?: Date | null;
    resultsDate?: Date | null;
    laboratory?: BaseNomDTO;
    receiptServiceId?: number | null;
    registerNumber?: number;
    externalLaboratory?: BaseNomDTO;
    uniqueNumber?: number;
    hasInvalidTests?: boolean | null;
    quantitySampled?: string | null;
    expressMedicalAnalysisValue?: string | null;
    document?: DocumentDTO;
    isExpress?: boolean | null;
}


export class RequestMedicalAnalysisTestGroupDTO implements IRequestMedicalAnalysisTestGroupDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
    isDefaultChecked?: boolean | null;
    isDefaultExpanded?: boolean | null;
    canSelectTests?: boolean | null;
    canUncheckAll?: boolean | null;
    service?: ServiceDTO;

    constructor(data?: IRequestMedicalAnalysisTestGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.isDefaultChecked = _data["isDefaultChecked"] !== undefined ? _data["isDefaultChecked"] : <any>null;
            this.isDefaultExpanded = _data["isDefaultExpanded"] !== undefined ? _data["isDefaultExpanded"] : <any>null;
            this.canSelectTests = _data["canSelectTests"] !== undefined ? _data["canSelectTests"] : <any>null;
            this.canUncheckAll = _data["canUncheckAll"] !== undefined ? _data["canUncheckAll"] : <any>null;
            this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>null;
        }
    }

    static fromJS(data: any): RequestMedicalAnalysisTestGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestMedicalAnalysisTestGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["isDefaultChecked"] = this.isDefaultChecked !== undefined ? this.isDefaultChecked : <any>null;
        data["isDefaultExpanded"] = this.isDefaultExpanded !== undefined ? this.isDefaultExpanded : <any>null;
        data["canSelectTests"] = this.canSelectTests !== undefined ? this.canSelectTests : <any>null;
        data["canUncheckAll"] = this.canUncheckAll !== undefined ? this.canUncheckAll : <any>null;
        data["service"] = this.service ? this.service.toJSON() : <any>null;
        return data;
    }
}

export interface IRequestMedicalAnalysisTestGroupDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
    isDefaultChecked?: boolean | null;
    isDefaultExpanded?: boolean | null;
    canSelectTests?: boolean | null;
    canUncheckAll?: boolean | null;
    service?: ServiceDTO;
}


export class PredefinedColorDTO implements IPredefinedColorDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;

    constructor(data?: IPredefinedColorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
        }
    }

    static fromJS(data: any): PredefinedColorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedColorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        return data;
    }
}

export interface IPredefinedColorDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
}



export class TestTubeTypeDTO implements ITestTubeTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
    quantityToSample?: string | null;
    predefinedColor?: PredefinedColorDTO;
    sampleType?: SampleTypeDTO;
    equipmentSampleType?: BaseNomDTO;
    canMixAllTogether?: boolean | null;

    constructor(data?: ITestTubeTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.quantityToSample = _data["quantityToSample"] !== undefined ? _data["quantityToSample"] : <any>null;
            this.predefinedColor = _data["predefinedColor"] ? PredefinedColorDTO.fromJS(_data["predefinedColor"]) : <any>null;
            this.sampleType = _data["sampleType"] ? SampleTypeDTO.fromJS(_data["sampleType"]) : <any>null;
            this.equipmentSampleType = _data["equipmentSampleType"] ? BaseNomDTO.fromJS(_data["equipmentSampleType"]) : <any>null;
            this.canMixAllTogether = _data["canMixAllTogether"] !== undefined ? _data["canMixAllTogether"] : <any>null;
        }
    }

    static fromJS(data: any): TestTubeTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TestTubeTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["quantityToSample"] = this.quantityToSample !== undefined ? this.quantityToSample : <any>null;
        data["predefinedColor"] = this.predefinedColor ? this.predefinedColor.toJSON() : <any>null;
        data["sampleType"] = this.sampleType ? this.sampleType.toJSON() : <any>null;
        data["equipmentSampleType"] = this.equipmentSampleType ? this.equipmentSampleType.toJSON() : <any>null;
        data["canMixAllTogether"] = this.canMixAllTogether !== undefined ? this.canMixAllTogether : <any>null;
        return data;
    }
}

export interface ITestTubeTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
    quantityToSample?: string | null;
    predefinedColor?: PredefinedColorDTO;
    sampleType?: SampleTypeDTO;
    equipmentSampleType?: BaseNomDTO;
    canMixAllTogether?: boolean | null;
}

export class MedicalAnalysisTestDTO implements IMedicalAnalysisTestDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
    requestMedicalAnalysisTestGroupDTO?: RequestMedicalAnalysisTestGroupDTO;
    medicalAnalysis?: MedicalAnalysisDTO;
    testTubeType?: TestTubeTypeDTO;
    equipmentType?: BaseNomDTO;
    externalLaboratory?: BaseNomDTO;
    service?: ServiceDTO;
    notVisibleForRequest?: boolean | null;
    descriptionRequired?: boolean | null;

    constructor(data?: IMedicalAnalysisTestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.requestMedicalAnalysisTestGroupDTO = _data["requestMedicalAnalysisTestGroupDTO"] ? RequestMedicalAnalysisTestGroupDTO.fromJS(_data["requestMedicalAnalysisTestGroupDTO"]) : <any>null;
            this.medicalAnalysis = _data["medicalAnalysis"] ? MedicalAnalysisDTO.fromJS(_data["medicalAnalysis"]) : <any>null;
            this.testTubeType = _data["testTubeType"] ? TestTubeTypeDTO.fromJS(_data["testTubeType"]) : <any>null;
            this.equipmentType = _data["equipmentType"] ? BaseNomDTO.fromJS(_data["equipmentType"]) : <any>null;
            this.externalLaboratory = _data["externalLaboratory"] ? BaseNomDTO.fromJS(_data["externalLaboratory"]) : <any>null;
            this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>null;
            this.notVisibleForRequest = _data["notVisibleForRequest"] !== undefined ? _data["notVisibleForRequest"] : <any>null;
            this.descriptionRequired = _data["descriptionRequired"] !== undefined ? _data["descriptionRequired"] : <any>null;
        }
    }

    static fromJS(data: any): MedicalAnalysisTestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAnalysisTestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["requestMedicalAnalysisTestGroupDTO"] = this.requestMedicalAnalysisTestGroupDTO ? this.requestMedicalAnalysisTestGroupDTO.toJSON() : <any>null;
        data["medicalAnalysis"] = this.medicalAnalysis ? this.medicalAnalysis.toJSON() : <any>null;
        data["testTubeType"] = this.testTubeType ? this.testTubeType.toJSON() : <any>null;
        data["equipmentType"] = this.equipmentType ? this.equipmentType.toJSON() : <any>null;
        data["externalLaboratory"] = this.externalLaboratory ? this.externalLaboratory.toJSON() : <any>null;
        data["service"] = this.service ? this.service.toJSON() : <any>null;
        data["notVisibleForRequest"] = this.notVisibleForRequest !== undefined ? this.notVisibleForRequest : <any>null;
        data["descriptionRequired"] = this.descriptionRequired !== undefined ? this.descriptionRequired : <any>null;
        return data;
    }
}

export interface IMedicalAnalysisTestDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
    requestMedicalAnalysisTestGroupDTO?: RequestMedicalAnalysisTestGroupDTO;
    medicalAnalysis?: MedicalAnalysisDTO;
    testTubeType?: TestTubeTypeDTO;
    equipmentType?: BaseNomDTO;
    externalLaboratory?: BaseNomDTO;
    service?: ServiceDTO;
    notVisibleForRequest?: boolean | null;
    descriptionRequired?: boolean | null;
}



export class MedicalAnalysisWithTestsDTO implements IMedicalAnalysisWithTestsDTO {
    medicalAnalysis?: MedicalAnalysisDTO;
    medicalAnalysisTests?: MedicalAnalysisTestDTO[] | null;

    constructor(data?: IMedicalAnalysisWithTestsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalAnalysis = _data["medicalAnalysis"] ? MedicalAnalysisDTO.fromJS(_data["medicalAnalysis"]) : <any>null;
            if (Array.isArray(_data["medicalAnalysisTests"])) {
                this.medicalAnalysisTests = [] as any;
                for (let item of _data["medicalAnalysisTests"])
                    this.medicalAnalysisTests!.push(MedicalAnalysisTestDTO.fromJS(item));
            }
            else {
                this.medicalAnalysisTests = <any>null;
            }
        }
    }

    static fromJS(data: any): MedicalAnalysisWithTestsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAnalysisWithTestsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalAnalysis"] = this.medicalAnalysis ? this.medicalAnalysis.toJSON() : <any>null;
        if (Array.isArray(this.medicalAnalysisTests)) {
            data["medicalAnalysisTests"] = [];
            for (let item of this.medicalAnalysisTests)
                data["medicalAnalysisTests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMedicalAnalysisWithTestsDTO {
    medicalAnalysis?: MedicalAnalysisDTO;
    medicalAnalysisTests?: MedicalAnalysisTestDTO[] | null;
}

export class MedicalAnalysisResultMedicalAnalysisTestDTO implements IMedicalAnalysisResultMedicalAnalysisTestDTO {
    id?: number;
    writeRevision?: boolean | null;
    medicalAnalysisResult?: MedicalAnalysisResultDTO;
    medicalAnalysisTest?: MedicalAnalysisTestDTO;
    receiptService?: BaseDTO;
    value?: string | null;

    constructor(data?: IMedicalAnalysisResultMedicalAnalysisTestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.medicalAnalysisResult = _data["medicalAnalysisResult"] ? MedicalAnalysisResultDTO.fromJS(_data["medicalAnalysisResult"]) : <any>null;
            this.medicalAnalysisTest = _data["medicalAnalysisTest"] ? MedicalAnalysisTestDTO.fromJS(_data["medicalAnalysisTest"]) : <any>null;
            this.receiptService = _data["receiptService"] ? BaseDTO.fromJS(_data["receiptService"]) : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): MedicalAnalysisResultMedicalAnalysisTestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAnalysisResultMedicalAnalysisTestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["medicalAnalysisResult"] = this.medicalAnalysisResult ? this.medicalAnalysisResult.toJSON() : <any>null;
        data["medicalAnalysisTest"] = this.medicalAnalysisTest ? this.medicalAnalysisTest.toJSON() : <any>null;
        data["receiptService"] = this.receiptService ? this.receiptService.toJSON() : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IMedicalAnalysisResultMedicalAnalysisTestDTO {
    id?: number;
    writeRevision?: boolean | null;
    medicalAnalysisResult?: MedicalAnalysisResultDTO;
    medicalAnalysisTest?: MedicalAnalysisTestDTO;
    receiptService?: BaseDTO;
    value?: string | null;
}